import { deserialize } from "jsonapi-fractal";

import {
  BaseAPI,
} from '@/internal';

export default class TradeAPI extends BaseAPI {

  index(params) {
    const { prependURL } = params;
    delete params.prependURL;

    const prepend = prependURL || '';

    return this.get({
      url: `${prepend}trades`,
      headers: [],
      queryParams: params,
    }).then(res => this.processResponse(res)
    ).then(res => {
      return {
        links: res.links,
        paginator: res.meta && res.meta.pagination ? res.meta.pagination : {},
        data: deserialize(res),
      }
    })
  }

};